var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('website-header'), _vm._v(" "), _c('personal-content', {
    attrs: {
      "countryCode": _vm.countryCode,
      "personalid": _vm.personalid
    }
  }), _vm._v(" "), _c('website-footer', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0px"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };